export const STORAGE_USER_DATA = 'userData';
export const STORAGE_POPUPS = 'popups';
export const STORAGE_PUSH_NOTIFICATIONS = 'push-notifications';
export const STORAGE_EDIT_PROFILE = 'edit-profile';
export const STORAGE_REDIRECT_BBVA = 'redirect-bbva';
export const STORAGE_VAULT = 'vault';
